// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider, useSelector } from "react-redux";
import { combineReducers, createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import GlobalLoaderReducer from "./store/GlobalLoader/GlobalLoaderReducer";
import UsersReducer from "./store/Users/UsersReducer";
import { webportalAppRootSaga } from "./store";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import LanguageReducer from "./store/Languages/LanguageReducer";
import TabReducer from "./store/Tab/reducer";
import ChurchReducer from "./store/Churches/reducer";
import ResourceReducer from './store/Resources/reducer'
import TeamReducer from "./store/Team/reducer";
import ProgramReducer from "./store/Program/programReducer";
import BulletinReducer from "./store/Bulletin/bulletinReducer";
import CarecellReducer from "./store/Carecells/reducer";
import CarecellCoverImageReducer from "./store/CarecellCoverImage/carecellCoverImageReducer";
import ProgramCoverImageReducer from "./store/ProgramCoverImage/reducer";
import TeamCoverImageReducer from "./store/TeamCoverImage/reducer";
import BulletinCoverImageReducer from "./store/BulletinCoverImage/bulletinCoverImageReducer";
import GalleryImageReducer from "./store/Gallery/galleryReducer";
import campusesReducer from "./store/Campuse/campusesReducer";
import servicesReducer from "./store/Service/servicesReducer";
import languageMetaReducer from "./store/ChurchLanguage/reducer";
import programLanguageMetaReducer from "./store/ProgramLanguage/reducer";
import ministryReducer from "./store/Ministry/reducer";
import channelsReducer from "./store/Channels/reducer";
import teamlanguageReducer from "./store/TeamLanguage/reducer"
import giveSettingReducer from "./store/GiveSetting/giveSettingReducer";
import videoResourcesReducer from "./store/VideoResouce/videoResourcesReducer";
import churchVideoReducer from "./store/ChurchVideos/churchVideoReducer";
import bulletinVideosReducer from "./store/BulletinVideo/bulletinVideosReducer";
import programVideosReducer from "./store/ProgramVIdeo/programVideosReducer";
import resourceVideosReducer from "./store/ResouceVideo/resourceVideosReducer";
import carecellVideoReducer from "./store/carecellVideo/carecellVideoReducer";
import serviceVideosReducer from "./store/ServiceVideo/serviceVideosReducer";
import campusVideoReducer from "./store/CampusVideo/CampusVideoReducer";
import teamVideoReducer from "./store/TeamVideo/teamVideoReducer";
import planReducer from "./store/Plan/planReducer";
import plansReducer from "./store/planChurch/reducer";
import groupsReducer from "./store/Group/reducer";
import bibleReducer from "./store/Bible/BibleReducer";
import prayersReducer from "./store/Prayer/PrayersReducer";
import sermonStudiesReducer from "./store/SermonStudies/sermonStudiesReducer";
import agreementsReducer from "./store/Agreements/agreementsReducer";
import entityAnalyticsReducer from "./store/EntityAnalytics/entityAnalyticsReducer";
const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

const reducers = combineReducers({
  globalLoader: GlobalLoaderReducer,
  user: UsersReducer,
  bible:bibleReducer,
  language: LanguageReducer,
  tab: TabReducer,
  churches: ChurchReducer,
  resources:ResourceReducer,
  teams:TeamReducer,
  programs:ProgramReducer,
  bulletin:BulletinReducer,
  carecell:CarecellReducer,
  carecellcover:CarecellCoverImageReducer,
  programcover:ProgramCoverImageReducer,
  teamCover:TeamCoverImageReducer,
  bulletinCover:BulletinCoverImageReducer,
  gallery: GalleryImageReducer,
  campuses: campusesReducer,
  service:servicesReducer,
  languageMeta:languageMetaReducer,
  programLanguageMeta:programLanguageMetaReducer,
  ministry:ministryReducer,
  channel:channelsReducer,
  teamLanguage:teamlanguageReducer,
  giveSetting:giveSettingReducer,
  videoResource:videoResourcesReducer,
 churchVideo:churchVideoReducer,
 bulletinVideo:bulletinVideosReducer,
 programVideos:programVideosReducer,
 resourceVideos:resourceVideosReducer,
 carecellVideo:carecellVideoReducer,
 serviceVideos:serviceVideosReducer,
 campusVideo:campusVideoReducer,
 teamVideo:teamVideoReducer,
 plan:planReducer,
 plansChurch:plansReducer,
groups:groupsReducer,
    prayers:prayersReducer,
  sermonStudies: sermonStudiesReducer,
  agreements: agreementsReducer,
  entityAnalytics: entityAnalyticsReducer

});

const sagaMiddleware = createSagaMiddleware();
const store = createStore(reducers, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(webportalAppRootSaga);

// ✅ Loader Wrapper
const AppWrapper = () => {
  const { userInfo } = useSelector((state) => state.user);
  const { error, logout } = useAuth0();

  React.useEffect(() => {
    const errorText = `${error?.error || ""} ${error?.error_description || ""} ${error?.message || ""}`.toLowerCase();
    const hasInvalidGrant = errorText.includes("invalid_grant") || errorText.includes("invalid refresh token");

    if (!hasInvalidGrant) return;

    localStorage.clear();
    logout({ logoutParams: { returnTo: window.location.origin } });
  }, [error, logout]);

  if (!userInfo) {
    return (
      <div className="flex items-center justify-center h-screen w-screen text-xl font-bold">
        Loading...
      </div>
    );
  }

  return <App />;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    cacheLocation="localstorage"
    useRefreshTokens={true}
    useRefreshTokensFallback={true}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: process.env.REACT_APP_AUDIENCE_URL,
      scope: "openid profile email offline_access",
    }}
  >
    <Provider store={store}>
      <GoogleOAuthProvider clientId="490413240407-jrqrupdrda8gimvrbt3o3bvs4qtcjgv2.apps.googleusercontent.com">
        <AppWrapper />
      </GoogleOAuthProvider>
    </Provider>
  </Auth0Provider>
);
